// import React, {
//   createContext,
//   useContext,
//   useEffect,
//   useState,
//   useMemo,
// } from 'react';
// import axios from 'axios';
// import { parseJWT } from 'helper/jwt';
// import { VITE_POLL } from 'src/private/config';

// interface User {
//   userId: string;
//   username: string;
// }

// interface PollingContextType {
//   activeUsers: User[];
//   activeUsersCount: number;
// }

// const PollingContext = createContext<PollingContextType | undefined>(undefined);

// interface PollingProviderProps {
//   children: React.ReactNode;
//   authorization: string;
// }

// export const PollingProvider: React.FC<PollingProviderProps> = ({
//   children,
//   authorization,
// }) => {
//   const token = parseJWT(authorization);
//   const [activeUsers, setActiveUsers] = useState<User[]>([]);
//   const [activeUsersCount, setActiveUsersCount] = useState(0);

//   useEffect(() => {
//     let timeoutId: NodeJS.Timeout | null = null;

//     const pollActiveUsers = async () => {
//       try {
//         const response = await axios.get(
//           `${VITE_POLL}/poll/active-users?userId=${token.id}&username=${token.username}`,
//         );
//         const data = response.data;
//         setActiveUsers(data.activeUsers);
//         setActiveUsersCount(data.activeUsersCount);
//       } catch (error) {
//         console.error('Error polling active users:', error);
//       } finally {
//         timeoutId = setTimeout(pollActiveUsers, 60000); // Poll every 1 minute
//       }
//     };

//     pollActiveUsers(); // Start polling when the component mounts

//     // Notify backend when the user logs out or closes the tab/browser
//     const handleUserLogout = async () => {
//       try {
//         await axios.post(`${VITE_POLL}/poll/update-users`, {
//           userId: token.id,
//           username: token.username,
//           action: 'disconnect',
//         });
//       } catch (error) {
//         console.error('Error disconnecting user:', error);
//       }
//     };

//     // Detect when the user logs out or closes the browser
//     window.addEventListener('beforeunload', handleUserLogout);

//     return () => {
//       if (timeoutId) clearTimeout(timeoutId);

//       window.removeEventListener('beforeunload', handleUserLogout);
//       handleUserLogout(); // Notify the server when the component is unmounted
//     };
//   }, []);

//   const value = useMemo(
//     () => ({ activeUsers, activeUsersCount }),
//     [activeUsers, activeUsersCount],
//   );

//   return (
//     <PollingContext.Provider value={value}>{children}</PollingContext.Provider>
//   );
// };

// export const usePollingContext = () => {
//   const context = useContext(PollingContext);
//   if (!context) {
//     throw new Error('usePollingContext must be used within a PollingProvider');
//   }
//   return context;
// };

// import React, {
//   createContext,
//   useContext,
//   useEffect,
//   useState,
//   useMemo,
// } from 'react';
// import axios from 'axios';
// import { parseJWT } from 'helper/jwt';
// import { VITE_POLL } from 'src/private/config';

// interface User {
//   userId: string;
//   username: string;
// }

// interface PollingContextType {
//   activeUsers: User[];
//   activeUsersCount: number;
// }

// const PollingContext = createContext<PollingContextType | undefined>(undefined);

// interface PollingProviderProps {
//   children: React.ReactNode;
//   authorization: string;
// }

// export const PollingProvider: React.FC<PollingProviderProps> = ({
//   children,
//   authorization,
// }) => {
//   const token = parseJWT(authorization);
//   const [activeUsers, setActiveUsers] = useState<User[]>([]);
//   const [activeUsersCount, setActiveUsersCount] = useState(0);

//   useEffect(() => {
//     let timeoutId: NodeJS.Timeout | null = null;

//     const pollActiveUsers = async () => {
//       try {
//         const response = await axios.get(
//           `${VITE_POLL}/poll/active-users?userId=${token.id}&username=${token.username}`,
//         );
//         const data = response.data;
//         setActiveUsers(data.activeUsers);
//         setActiveUsersCount(data.activeUsersCount);
//       } catch (error) {
//         console.error('Error polling active users:', error);
//       } finally {
//         timeoutId = setTimeout(pollActiveUsers, 60000); // Poll every 1 minute
//       }
//     };

//     pollActiveUsers(); // Start polling when the component mounts

//     const handleUserLogout = async () => {
//       try {
//         await axios.post(`${VITE_POLL}/poll/update-users`, {
//           userId: token.id,
//           username: token.username,
//           action: 'disconnect',
//         });
//       } catch (error) {
//         console.error('Error disconnecting user:', error);
//       }
//     };

//     const handleVisibilityChange = () => {
//       if (document.visibilityState === 'hidden') {
//         handleUserLogout(); // Disconnect when the tab becomes hidden
//       }
//     };

//     window.addEventListener('beforeunload', handleUserLogout);
//     document.addEventListener('visibilitychange', handleVisibilityChange);

//     return () => {
//       if (timeoutId) clearTimeout(timeoutId);
//       window.removeEventListener('beforeunload', handleUserLogout);
//       document.removeEventListener('visibilitychange', handleVisibilityChange);
//       handleUserLogout(); // Notify the server when the component is unmounted
//     };
//   }, []);

//   const value = useMemo(
//     () => ({ activeUsers, activeUsersCount }),
//     [activeUsers, activeUsersCount],
//   );

//   return (
//     <PollingContext.Provider value={value}>{children}</PollingContext.Provider>
//   );
// };

// export const usePollingContext = () => {
//   const context = useContext(PollingContext);
//   if (!context) {
//     throw new Error('usePollingContext must be used within a PollingProvider');
//   }
//   return context;
// };

import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useMemo,
} from 'react';
import axios from 'axios';
import { parseJWT } from 'helper/jwt';
import { VITE_POLL } from 'src/private/config';
import { Alert } from 'antd';
import { getCookie, setCookie } from 'helper/cookie';

interface User {
  userId: string;
  username: string;
  sessionId?: string;
}


interface PollingContextType {
  activeUsers: User[];
  activeUsersCount: number;
  sessionId?: string;
}

const PollingContext = createContext<PollingContextType | undefined>(undefined);

interface PollingProviderProps {
  children: React.ReactNode;
  authorization: string;
}

export const PollingProvider: React.FC<PollingProviderProps> = ({
  children,
  authorization,
}) => {
  const token = parseJWT(authorization);
  const [activeUsers, setActiveUsers] = useState<User[]>([]);
  const [activeUsersCount, setActiveUsersCount] = useState(0);
  const [showDuplicateLoginAlert, setShowDuplicateLoginAlert] = useState(false);
  const [alertClosed, setAlertClosed] = useState(false); 
  const sessionId: string | undefined = getCookie('sessionId');

  useEffect(() => {
    let timeoutId: NodeJS.Timeout | null = null;

    // const pollActiveUsers = async () => {
    //   try {
    //     const response = await axios.get(
    //       `${VITE_POLL}/poll/active-users?userId=${token.id}&username=${token.username}`,
    //     );
    //     const data = response.data;
    //     setActiveUsers(data.activeUsers);
    //     setActiveUsersCount(data.activeUsersCount);
    //   } catch (error) {
    //     console.error('Error polling active users:', error);
    //   } finally {
    //     timeoutId = setTimeout(pollActiveUsers, 60000); // Poll every 1 minute
    //   }
    // };

    const pollActiveUsers = async () => {
      try {
        const response = await axios.get(
          `${VITE_POLL}/poll/active-users?userId=${token.id}&username=${token.username}&sessionId=${sessionId || ''}`,
        );
        const data = response.data;
        setActiveUsers(data.activeUsers);
        setActiveUsersCount(data.activeUsersCount);

        if (!sessionId && data.sessionId) {
          setCookie('sessionId', data?.sessionId);
        }

        const sameUsernameCount = data.activeUsers.filter(
          (user: User) => user.username.toLowerCase() === token.username.toLowerCase()
        ).length;
        // console.log('sameUsernameCount',sameUsernameCount)
        // Check if there are multiple logins for the same username
        if (sameUsernameCount > 1 && !showDuplicateLoginAlert && !alertClosed) {
          setShowDuplicateLoginAlert(true);
        } else if (sameUsernameCount === 1 && showDuplicateLoginAlert) {
          setShowDuplicateLoginAlert(false);
        }

      } catch (error) {
        console.error('Error polling active users:', error);
      } finally {
        timeoutId = setTimeout(pollActiveUsers, 60000); // Poll every 1 minute
      }
    };

    pollActiveUsers(); // Start polling when the component mounts

    const handleUserLogout = async () => {
      try {
        await axios.post(`${VITE_POLL}/poll/update-users`, {
          userId: token.id,
          username: token.username,
          action: 'disconnect',
          sessionId,
        });
        // localStorage.removeItem('sessionId'); 
      } catch (error) {
        console.error('Error disconnecting user:', error);
      }
    };

    // Only notify backend if the user is actually closing the tab or browser
    window.addEventListener('beforeunload', handleUserLogout);

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      window.removeEventListener('beforeunload', handleUserLogout);
      handleUserLogout(); // Notify the server when the component is unmounted
    };
  }, [showDuplicateLoginAlert, alertClosed]);

  const value = useMemo(
    () => ({ activeUsers, activeUsersCount }),
    [activeUsers, activeUsersCount],
  );
  // console.log('showDuplicateLoginAlert',showDuplicateLoginAlert)
  return (
    <PollingContext.Provider value={value}>
    {children}
    {showDuplicateLoginAlert && (
      <div style={{ position: 'absolute', top: 0, right: 0, zIndex: 1000 }}>
        <Alert
          message="ตรวจพบการเข้าสู่ระบบซ้ำ"
          description="หากไม่ใช่คุณ แนะนำให้เปลี่ยนรหัสผ่าน"
          type="warning"
          showIcon
          closable
          // style={{ height: '80px' }}
          onClose={() => {
            setShowDuplicateLoginAlert(false);
            setAlertClosed(true); // Prevent the alert from reappearing immediately
          }}
        />
      </div>
    )}
  </PollingContext.Provider>
  );
};

export const usePollingContext = () => {
  const context = useContext(PollingContext);
  if (!context) {
    throw new Error('usePollingContext must be used within a PollingProvider');
  }
  return context;
};
